import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { AuthUser, Organization } from '@nargus/shared';
import { Link } from '@tanstack/react-router';
import { Share2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PhotoLibrary } from './photo-library';
import { PhotoShareDialog } from './photo-share-dialog';

export function PhotoTabs({
  organizationId,
  active,
}: {
  organizationId: string;
  active: 'photos' | 'albums';
}) {
  const { t } = useTranslation();

  return (
    <nav className="flex gap-1">
      <Button
        variant={active === 'photos' ? 'secondary' : 'ghost'}
        size="sm"
        render={
          <Link to="/organizations/$organizationId/photos" params={{ organizationId }} />
        }
      >
        {t('photos.title')}
      </Button>
      <Button
        variant={active === 'albums' ? 'secondary' : 'ghost'}
        size="sm"
        render={
          <Link
            to="/organizations/$organizationId/photos/albums"
            params={{ organizationId }}
          />
        }
      >
        {t('albums.title')}
      </Button>
    </nav>
  );
}

export function PhotosSection({
  organization,
  user,
}: {
  organization: Organization;
  user: AuthUser;
}) {
  const { t } = useTranslation();
  const [sharing, setSharing] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <PhotoTabs organizationId={organization.id} active="photos" />

      <PhotoLibrary
        organization={organization}
        user={user}
        title={t('photos.title')}
        hint={t('photos.hint')}
        actions={
          <Button type="button" variant="outline" onClick={() => setSharing(true)}>
            <Share2 />
            {t('shares.manage')}
          </Button>
        }
      />

      {sharing && (
        <PhotoShareDialog organization={organization} onClose={() => setSharing(false)} />
      )}
    </div>
  );
}
